<script setup lang="ts">
import TheNavLinks from "~/components/TheNavLinks.vue";

const navLoaded = ref(false);

onMounted(() => {
  setTimeout(() => {
    navLoaded.value = true;
  }, 150);
});
</script>

<template>
  <header
    class="fixed top-0 left-0 w-screen text-base-content border-b border-base-100 h-24 drop-shadow-xs z-50 bg-gray-700/90 backdrop-blur-sm"
  >
    <div class="navbar py-6">
      <div class="navbar-start flex-1 md:flex-auto lg:ml-2">
        <div class="dropdown">
          <div class="m-1 btn btn-ghost lg:hidden" tabindex="0" role="button">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
              viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" />
            </svg>
          </div>

          <ul tabindex="0" class="nav dropdown-content menu lg:hidden mt-3 z-1 p-4 pt-2 pb-0 shadow-xl bg-base-300 w-80 rounded-xs">
            <TheNavLinks text-size="text-lg" />
          </ul>
        </div>

        <NuxtLink to="/" class="mr-auto visible"
          title="Scripted Pixels: Design, Develop, Deliver">
          <div class="flex w-48 gap-2 md:w-60 lg:w-80 items-center">
            <svg class="scriptedSVG" :class="{ active: navLoaded }" width="289"
              height="51" viewBox="0 0 289 51" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_3_21" fill="white">
                <path
                  d="M0.699707 37.6953L1.89571 37.5583L1.96471 38.0383C2.32871 41.5093 4.09771 44.2263 7.27371 46.1903C10.4487 48.1543 13.8797 49.1353 17.5667 49.1353C22.2887 49.1353 26.3267 47.7373 29.6797 44.9393C32.3037 42.7563 33.6257 40.0273 33.6487 36.7523C33.6487 35.8423 33.5457 34.8873 33.3397 33.8863C32.9267 31.9313 32.0207 30.3723 30.6217 29.2133C29.2217 28.0523 27.5997 27.2623 25.7537 26.8413C23.9067 26.4213 21.8987 26.0793 19.7287 25.8153C17.5587 25.5523 15.4347 25.2943 13.3547 25.0413C11.2747 24.7893 9.34871 24.3463 7.57571 23.7143C5.80371 23.0813 4.34871 21.9713 3.21271 20.3843C2.07571 18.7973 1.41071 16.7603 1.21671 14.2763C1.16771 13.8623 1.14371 13.4473 1.14371 13.0333C1.14371 10.4583 1.93171 8.1533 3.50971 6.1193C5.84171 3.1143 9.23471 1.2063 13.6927 0.392303C15.0407 0.144303 16.3777 0.0193024 17.7037 0.0193024C20.6987 0.0193024 23.5557 0.662302 26.2767 1.9483C30.2087 3.7983 32.5527 6.7073 33.3067 10.6773L33.3757 11.2523L32.2517 11.4573L32.1787 10.8753C31.7687 8.8203 30.8817 7.0503 29.5167 5.5663C26.7167 2.5753 22.7907 1.0793 17.7377 1.0793H17.2937C14.7667 1.1253 12.3487 1.6173 10.0387 2.5563C7.72871 3.4953 5.87971 4.8803 4.49171 6.7123C3.01171 8.5213 2.27171 10.6743 2.27171 13.1693C2.27171 13.5133 2.28271 13.8683 2.30571 14.2343C2.48671 16.5703 3.14871 18.4533 4.29071 19.8843C5.43271 21.3163 6.86971 22.3123 8.59971 22.8733C10.3307 23.4343 12.2417 23.8363 14.3317 24.0783C16.4227 24.3203 18.5357 24.5653 20.6727 24.8133C22.8087 25.0613 24.8197 25.4303 26.7047 25.9213C28.5907 26.4113 30.2297 27.3003 31.6207 28.5893C33.0117 29.8783 33.9377 31.5713 34.3977 33.6703C34.6277 34.6963 34.7537 35.6883 34.7767 36.6473C34.7767 38.0153 34.5367 39.3383 34.0567 40.6153C33.2567 42.7593 32.0057 44.5103 30.3037 45.8673C28.6007 47.2253 26.6347 48.2853 24.4067 49.0493C22.1777 49.8133 19.8747 50.1953 17.4987 50.1953C13.5217 50.1953 9.83571 49.1193 6.44171 46.9673C3.04771 44.8153 1.15671 41.8843 0.767707 38.1753L0.699707 37.6953Z"
                  class="svg-elem-1"></path>
                <path
                  d="M36.6226 25.2783C36.6226 18.6023 38.9696 12.8603 43.6636 8.0513C48.3576 3.2443 54.0196 0.840302 60.6506 0.840302C67.2816 0.840302 72.9216 3.2443 77.5696 8.0513C79.7576 10.2853 81.4436 12.8373 82.6286 15.7083H81.4326C80.3606 13.1663 78.8226 10.8653 76.8176 8.8033C72.3746 4.2013 66.9796 1.8993 60.6336 1.8993C54.2876 1.8993 48.9046 4.1963 44.4836 8.7903C39.9946 13.4293 37.7506 18.9253 37.7506 25.2783C37.7506 31.7003 39.9946 37.2083 44.4836 41.8003C48.9726 46.4403 54.3616 48.7543 60.6506 48.7423C66.9396 48.7313 72.3286 46.4133 76.8176 41.7873C78.8686 39.6803 80.4066 37.4013 81.4326 34.9513H82.6286C81.4666 37.7993 79.7796 40.3403 77.5696 42.5733C72.8986 47.3813 67.2526 49.7853 60.6336 49.7853C54.0146 49.7853 48.3576 47.3813 43.6636 42.5733C38.9696 37.7653 36.6226 32.0003 36.6226 25.2783Z"
                  class="svg-elem-2"></path>
                <path
                  d="M87.8579 49.7168V0.702805H104.829C107.202 0.702805 109.346 1.1128 111.262 1.9288C113.178 2.7468 114.723 3.8308 115.898 5.1818C117.073 6.5328 117.974 8.0538 118.602 9.7458C119.229 11.4378 119.543 13.1858 119.543 14.9898C119.543 16.7958 119.23 18.5538 118.604 20.2668C117.978 21.9798 117.078 23.5098 115.906 24.8578C114.734 26.2058 113.192 27.2898 111.28 28.1128C109.368 28.9348 107.229 29.3458 104.862 29.3458H96.9409L119.474 49.7168H117.868L95.3359 29.3458V28.2858H104.861C107.751 28.2858 110.255 27.6348 112.372 26.3328C114.488 25.0308 116.025 23.3978 116.981 21.4328C117.937 19.4678 118.415 17.3378 118.415 15.0418C118.415 12.7458 117.937 10.6148 116.981 8.6508C116.025 6.6858 114.488 5.0478 112.372 3.7338C110.255 2.4198 107.751 1.7628 104.861 1.7628H88.9859V49.7168H87.8579Z"
                  class="svg-elem-3"></path>
                <path
                  d="M122.653 49.7168V48.6568H133.009V1.8308H122.653V0.771805H144.494V1.8308H134.137V48.6568H144.494V49.7168H122.653Z"
                  class="svg-elem-4"></path>
                <path
                  d="M150.509 30.0634H166.334C168.522 30.0634 170.504 29.6524 172.281 28.8304C174.059 28.0074 175.494 26.9404 176.588 25.6264C177.682 24.3134 178.519 22.8054 179.1 21.1044C179.681 19.4024 179.972 17.6724 179.972 15.9134C179.972 14.1544 179.681 12.4244 179.1 10.7224C178.519 9.0214 177.682 7.5134 176.588 6.1994C175.494 4.8864 174.059 3.8184 172.281 2.9964C170.504 2.1734 168.522 1.7624 166.334 1.7624H150.509V30.0634ZM149.381 49.7164V0.7034H166.371C168.745 0.7034 170.892 1.1344 172.81 1.9974C174.729 2.8604 176.276 4.0014 177.452 5.4214C178.628 6.8404 179.53 8.4584 180.158 10.2754C180.786 12.0924 181.1 13.9604 181.1 15.8784C181.1 17.7974 180.786 19.6734 180.158 21.5054C179.53 23.3364 178.627 24.9634 177.451 26.3824C176.275 27.8024 174.728 28.9474 172.81 29.8174C170.891 30.6884 168.744 31.1234 166.369 31.1234H150.509V49.7164H149.381Z"
                  class="svg-elem-5"></path>
                <path
                  d="M176.178 1.76261V0.702606H211.041V1.76261H194.191V49.7166H193.063V1.76261H176.178Z"
                  class="svg-elem-6"></path>
                <path
                  d="M215.246 49.7168V0.771805H242.282V1.8308H216.374V24.7318H241.701V25.7908H216.374V48.6568H242.419V49.7168H215.246Z"
                  class="svg-elem-7"></path>
                <path
                  d="M248.571 48.6572H264.041C268.935 48.6572 273.175 47.5072 276.761 45.2052C280.347 42.9042 282.942 40.0102 284.548 36.5232C286.152 33.0372 286.955 29.2772 286.955 25.2442C286.955 21.2112 286.152 17.4572 284.548 13.9822C282.942 10.5072 280.347 7.61321 276.761 5.30021C273.175 2.98821 268.935 1.83121 264.041 1.83121H248.571V48.6572ZM247.443 49.7172V0.77121H263.972C267.842 0.77121 271.338 1.47221 274.456 2.87321C277.575 4.27521 280.102 6.12021 282.038 8.41021C283.973 10.7002 285.465 13.3152 286.511 16.2552C287.559 19.1942 288.083 22.1912 288.083 25.2442C288.083 28.2982 287.559 31.2942 286.511 34.2332C285.465 37.1732 283.973 39.7872 282.038 42.0772C280.102 44.3672 277.575 46.2132 274.456 47.6152C271.338 49.0162 267.842 49.7172 263.972 49.7172H247.443Z"
                  class="svg-elem-8"></path>
              </mask>
              <path
                d="M0.699707 37.6953L1.89571 37.5583L1.96471 38.0383C2.32871 41.5093 4.09771 44.2263 7.27371 46.1903C10.4487 48.1543 13.8797 49.1353 17.5667 49.1353C22.2887 49.1353 26.3267 47.7373 29.6797 44.9393C32.3037 42.7563 33.6257 40.0273 33.6487 36.7523C33.6487 35.8423 33.5457 34.8873 33.3397 33.8863C32.9267 31.9313 32.0207 30.3723 30.6217 29.2133C29.2217 28.0523 27.5997 27.2623 25.7537 26.8413C23.9067 26.4213 21.8987 26.0793 19.7287 25.8153C17.5587 25.5523 15.4347 25.2943 13.3547 25.0413C11.2747 24.7893 9.34871 24.3463 7.57571 23.7143C5.80371 23.0813 4.34871 21.9713 3.21271 20.3843C2.07571 18.7973 1.41071 16.7603 1.21671 14.2763C1.16771 13.8623 1.14371 13.4473 1.14371 13.0333C1.14371 10.4583 1.93171 8.1533 3.50971 6.1193C5.84171 3.1143 9.23471 1.2063 13.6927 0.392303C15.0407 0.144303 16.3777 0.0193024 17.7037 0.0193024C20.6987 0.0193024 23.5557 0.662302 26.2767 1.9483C30.2087 3.7983 32.5527 6.7073 33.3067 10.6773L33.3757 11.2523L32.2517 11.4573L32.1787 10.8753C31.7687 8.8203 30.8817 7.0503 29.5167 5.5663C26.7167 2.5753 22.7907 1.0793 17.7377 1.0793H17.2937C14.7667 1.1253 12.3487 1.6173 10.0387 2.5563C7.72871 3.4953 5.87971 4.8803 4.49171 6.7123C3.01171 8.5213 2.27171 10.6743 2.27171 13.1693C2.27171 13.5133 2.28271 13.8683 2.30571 14.2343C2.48671 16.5703 3.14871 18.4533 4.29071 19.8843C5.43271 21.3163 6.86971 22.3123 8.59971 22.8733C10.3307 23.4343 12.2417 23.8363 14.3317 24.0783C16.4227 24.3203 18.5357 24.5653 20.6727 24.8133C22.8087 25.0613 24.8197 25.4303 26.7047 25.9213C28.5907 26.4113 30.2297 27.3003 31.6207 28.5893C33.0117 29.8783 33.9377 31.5713 34.3977 33.6703C34.6277 34.6963 34.7537 35.6883 34.7767 36.6473C34.7767 38.0153 34.5367 39.3383 34.0567 40.6153C33.2567 42.7593 32.0057 44.5103 30.3037 45.8673C28.6007 47.2253 26.6347 48.2853 24.4067 49.0493C22.1777 49.8133 19.8747 50.1953 17.4987 50.1953C13.5217 50.1953 9.83571 49.1193 6.44171 46.9673C3.04771 44.8153 1.15671 41.8843 0.767707 38.1753L0.699707 37.6953Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-9"></path>
              <path
                d="M36.6226 25.2783C36.6226 18.6023 38.9696 12.8603 43.6636 8.0513C48.3576 3.2443 54.0196 0.840302 60.6506 0.840302C67.2816 0.840302 72.9216 3.2443 77.5696 8.0513C79.7576 10.2853 81.4436 12.8373 82.6286 15.7083H81.4326C80.3606 13.1663 78.8226 10.8653 76.8176 8.8033C72.3746 4.2013 66.9796 1.8993 60.6336 1.8993C54.2876 1.8993 48.9046 4.1963 44.4836 8.7903C39.9946 13.4293 37.7506 18.9253 37.7506 25.2783C37.7506 31.7003 39.9946 37.2083 44.4836 41.8003C48.9726 46.4403 54.3616 48.7543 60.6506 48.7423C66.9396 48.7313 72.3286 46.4133 76.8176 41.7873C78.8686 39.6803 80.4066 37.4013 81.4326 34.9513H82.6286C81.4666 37.7993 79.7796 40.3403 77.5696 42.5733C72.8986 47.3813 67.2526 49.7853 60.6336 49.7853C54.0146 49.7853 48.3576 47.3813 43.6636 42.5733C38.9696 37.7653 36.6226 32.0003 36.6226 25.2783Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-10"></path>
              <path
                d="M87.8579 49.7168V0.702805H104.829C107.202 0.702805 109.346 1.1128 111.262 1.9288C113.178 2.7468 114.723 3.8308 115.898 5.1818C117.073 6.5328 117.974 8.0538 118.602 9.7458C119.229 11.4378 119.543 13.1858 119.543 14.9898C119.543 16.7958 119.23 18.5538 118.604 20.2668C117.978 21.9798 117.078 23.5098 115.906 24.8578C114.734 26.2058 113.192 27.2898 111.28 28.1128C109.368 28.9348 107.229 29.3458 104.862 29.3458H96.9409L119.474 49.7168H117.868L95.3359 29.3458V28.2858H104.861C107.751 28.2858 110.255 27.6348 112.372 26.3328C114.488 25.0308 116.025 23.3978 116.981 21.4328C117.937 19.4678 118.415 17.3378 118.415 15.0418C118.415 12.7458 117.937 10.6148 116.981 8.6508C116.025 6.6858 114.488 5.0478 112.372 3.7338C110.255 2.4198 107.751 1.7628 104.861 1.7628H88.9859V49.7168H87.8579Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-11"></path>
              <path
                d="M122.653 49.7168V48.6568H133.009V1.8308H122.653V0.771805H144.494V1.8308H134.137V48.6568H144.494V49.7168H122.653Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-12"></path>
              <path
                d="M150.509 30.0634H166.334C168.522 30.0634 170.504 29.6524 172.281 28.8304C174.059 28.0074 175.494 26.9404 176.588 25.6264C177.682 24.3134 178.519 22.8054 179.1 21.1044C179.681 19.4024 179.972 17.6724 179.972 15.9134C179.972 14.1544 179.681 12.4244 179.1 10.7224C178.519 9.0214 177.682 7.5134 176.588 6.1994C175.494 4.8864 174.059 3.8184 172.281 2.9964C170.504 2.1734 168.522 1.7624 166.334 1.7624H150.509V30.0634ZM149.381 49.7164V0.7034H166.371C168.745 0.7034 170.892 1.1344 172.81 1.9974C174.729 2.8604 176.276 4.0014 177.452 5.4214C178.628 6.8404 179.53 8.4584 180.158 10.2754C180.786 12.0924 181.1 13.9604 181.1 15.8784C181.1 17.7974 180.786 19.6734 180.158 21.5054C179.53 23.3364 178.627 24.9634 177.451 26.3824C176.275 27.8024 174.728 28.9474 172.81 29.8174C170.891 30.6884 168.744 31.1234 166.369 31.1234H150.509V49.7164H149.381Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-13"></path>
              <path
                d="M176.178 1.76261V0.702606H211.041V1.76261H194.191V49.7166H193.063V1.76261H176.178Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-14"></path>
              <path
                d="M215.246 49.7168V0.771805H242.282V1.8308H216.374V24.7318H241.701V25.7908H216.374V48.6568H242.419V49.7168H215.246Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-15"></path>
              <path
                d="M248.571 48.6572H264.041C268.935 48.6572 273.175 47.5072 276.761 45.2052C280.347 42.9042 282.942 40.0102 284.548 36.5232C286.152 33.0372 286.955 29.2772 286.955 25.2442C286.955 21.2112 286.152 17.4572 284.548 13.9822C282.942 10.5072 280.347 7.61321 276.761 5.30021C273.175 2.98821 268.935 1.83121 264.041 1.83121H248.571V48.6572ZM247.443 49.7172V0.77121H263.972C267.842 0.77121 271.338 1.47221 274.456 2.87321C277.575 4.27521 280.102 6.12021 282.038 8.41021C283.973 10.7002 285.465 13.3152 286.511 16.2552C287.559 19.1942 288.083 22.1912 288.083 25.2442C288.083 28.2982 287.559 31.2942 286.511 34.2332C285.465 37.1732 283.973 39.7872 282.038 42.0772C280.102 44.3672 277.575 46.2132 274.456 47.6152C271.338 49.0162 267.842 49.7172 263.972 49.7172H247.443Z"
                stroke="white" stroke-width="2"
                mask="url(#path-1-inside-1_3_21)" class="svg-elem-16"></path>
            </svg>

            <svg class="pixelsSVG" :class="{ active: navLoaded }" ref="logo"
              width="207" height="52" viewBox="0 0 207 52" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.09 8.0692H7.91199V22.2472H22.09M22.09 8.0692V22.2472M22.09 8.0692V0.979202H0.824005V50.6022H7.91299V29.3352H22.09V22.2472M22.09 8.0692H29.179V22.2462L22.09 22.2472"
                stroke="#FF0000" stroke-miterlimit="10" class="svg-elem-1">
              </path>
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M57.393 50.602H36.125V43.513H43.214V8.069H36.125V0.979004H57.393V8.069H50.303V43.513H57.393V50.602Z"
                stroke="#3FA9F5" stroke-miterlimit="10" class="svg-elem-2">
              </path>
              <path
                d="M92.836 43.5132V50.6022H99.925V43.5132H92.836ZM92.836 43.5132H85.747V29.3352M92.836 43.5132V29.3352H85.747M92.836 8.06921H99.925V0.980209H92.836V8.06921ZM92.836 8.06921L85.747 8.06821V22.2462M92.836 8.06921V22.2462H85.747M85.747 29.3352H78.658M85.747 29.3352V22.2462M85.747 22.2462H78.658M78.658 29.3352V22.2462M78.658 29.3352H71.569V43.5132M78.658 29.3352V43.5132H71.569M78.658 22.2462H71.569V8.06821M78.658 22.2462V8.06821H71.569M71.569 43.5132H64.48V50.6022H71.569V43.5132ZM71.569 8.06821L64.48 8.06921V0.980209H71.569V8.06821Z"
                stroke="#52F800" stroke-miterlimit="10" class="svg-elem-3">
              </path>
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M135.439 50.602H107.084V0.979004H135.439V8.069H114.172V22.247H129.768V29.335H114.172V43.513H135.439V50.602Z"
                stroke="#B400FF" stroke-miterlimit="10" class="svg-elem-4">
              </path>
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M170.955 50.602H142.6V0.979004H149.688V43.513H170.955V50.602Z"
                stroke="#FF5400" stroke-miterlimit="10" class="svg-elem-5">
              </path>
              <path
                d="M199.31 43.5132H206.399V29.3352H199.31M199.31 43.5132V29.3352M199.31 43.5132H178.043V50.6022H199.31V43.5132ZM199.31 29.3352H185.132V22.2462M199.31 29.3352V22.2462H185.132M185.132 22.2462H178.043V8.06821L185.132 8.06921M185.132 22.2462V8.06921M185.132 8.06921H206.399V0.980209H185.132V8.06921Z"
                stroke="#FF0090" stroke-miterlimit="10" class="svg-elem-6">
              </path>
            </svg>
          </div>
        </NuxtLink>
      </div>

      <div class="navbar-end hidden lg:flex">
        <nav role="navigation" aria-label="main navigation" class="nav menu menu-horizontal gap-4">
          <TheNavLinks text-size="text-lg" />
        </nav>
      </div>
    </div>
  </header>
</template>

<style>
/***************************************************
 * Generated by SVG Artista on 2/15/2024, 10:42:01 AM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/

@keyframes animate-svg-stroke-1 {
  0% {
    stroke-dashoffset: 272.7630310058594px;
    stroke-dasharray: 272.7630310058594px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 272.7630310058594px;
  }
}

.scriptedSVG .svg-elem-1 {
  animation: animate-svg-stroke-1 1s ease-out 0s both;
}

@keyframes animate-svg-stroke-2 {
  0% {
    stroke-dashoffset: 262.6156005859375px;
    stroke-dasharray: 262.6156005859375px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 262.6156005859375px;
  }
}

.scriptedSVG .svg-elem-2 {
  animation: animate-svg-stroke-2 1s ease-out 0.2s both;
}

@keyframes animate-svg-stroke-3 {
  0% {
    stroke-dashoffset: 302.4282531738281px;
    stroke-dasharray: 302.4282531738281px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 302.4282531738281px;
  }
}

.scriptedSVG .svg-elem-3 {
  animation: animate-svg-stroke-3 1s ease-out 0.4s both;
}

@keyframes animate-svg-stroke-4 {
  0% {
    stroke-dashoffset: 184.99803161621094px;
    stroke-dasharray: 184.99803161621094px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 184.99803161621094px;
  }
}

.scriptedSVG .svg-elem-4 {
  animation: animate-svg-stroke-4 1s ease-out 0.6000000000000001s both;
}

@keyframes animate-svg-stroke-5 {
  0% {
    stroke-dashoffset: 255.10528564453125px;
    stroke-dasharray: 255.10528564453125px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 255.10528564453125px;
  }
}

.scriptedSVG .svg-elem-5 {
  animation: animate-svg-stroke-5 1s ease-out 0.8s both;
}

@keyframes animate-svg-stroke-6 {
  0% {
    stroke-dashoffset: 169.75399780273438px;
    stroke-dasharray: 169.75399780273438px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 169.75399780273438px;
  }
}

.scriptedSVG .svg-elem-6 {
  animation: animate-svg-stroke-6 1s ease-out 1s both;
}

@keyframes animate-svg-stroke-7 {
  0% {
    stroke-dashoffset: 256.70603942871094px;
    stroke-dasharray: 256.70603942871094px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 256.70603942871094px;
  }
}

.scriptedSVG .svg-elem-7 {
  animation: animate-svg-stroke-7 1s ease-out 1.2000000000000002s both;
}

@keyframes animate-svg-stroke-8 {
  0% {
    stroke-dashoffset: 312.3736572265625px;
    stroke-dasharray: 312.3736572265625px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 312.3736572265625px;
  }
}

.scriptedSVG .svg-elem-8 {
  animation: animate-svg-stroke-8 1s ease-out 1.4000000000000001s both;
}

@keyframes animate-svg-stroke-9 {
  0% {
    stroke-dashoffset: 272.7630310058594px;
    stroke-dasharray: 272.7630310058594px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 272.7630310058594px;
  }
}

.scriptedSVG .svg-elem-9 {
  animation: animate-svg-stroke-9 1s ease-out 1.6s both;
}

@keyframes animate-svg-stroke-10 {
  0% {
    stroke-dashoffset: 262.6156005859375px;
    stroke-dasharray: 262.6156005859375px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 262.6156005859375px;
  }
}

.scriptedSVG .svg-elem-10 {
  animation: animate-svg-stroke-10 1s ease-out 1.8s both;
}

@keyframes animate-svg-stroke-11 {
  0% {
    stroke-dashoffset: 302.4282531738281px;
    stroke-dasharray: 302.4282531738281px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 302.4282531738281px;
  }
}

.scriptedSVG .svg-elem-11 {
  animation: animate-svg-stroke-11 1s ease-out 2s both;
}

@keyframes animate-svg-stroke-12 {
  0% {
    stroke-dashoffset: 184.99803161621094px;
    stroke-dasharray: 184.99803161621094px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 184.99803161621094px;
  }
}

.scriptedSVG .svg-elem-12 {
  animation: animate-svg-stroke-12 1s ease-out 2.2s both;
}

@keyframes animate-svg-stroke-13 {
  0% {
    stroke-dashoffset: 255.10528564453125px;
    stroke-dasharray: 255.10528564453125px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 255.10528564453125px;
  }
}

.scriptedSVG .svg-elem-13 {
  animation: animate-svg-stroke-13 1s ease-out 2.4000000000000004s both;
}

@keyframes animate-svg-stroke-14 {
  0% {
    stroke-dashoffset: 169.75399780273438px;
    stroke-dasharray: 169.75399780273438px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 169.75399780273438px;
  }
}

.scriptedSVG .svg-elem-14 {
  animation: animate-svg-stroke-14 1s ease-out 2.6s both;
}

@keyframes animate-svg-stroke-15 {
  0% {
    stroke-dashoffset: 256.70603942871094px;
    stroke-dasharray: 256.70603942871094px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 256.70603942871094px;
  }
}

.scriptedSVG .svg-elem-15 {
  animation: animate-svg-stroke-15 1s ease-out 2.8000000000000003s both;
}

@keyframes animate-svg-stroke-16 {
  0% {
    stroke-dashoffset: 312.3736572265625px;
    stroke-dasharray: 312.3736572265625px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 312.3736572265625px;
  }
}

.scriptedSVG .svg-elem-16 {
  animation: animate-svg-stroke-16 1s ease-out 3s both;
}

/***************************************************
 * Generated by SVG Artista on 2/15/2024, 10:28:25 AM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/

.pixelsSVG .svg-elem-1 {
  stroke-dashoffset: 296.4300231933594px;
  stroke-dasharray: 296.4300231933594px;
  transition: stroke-dashoffset 1s ease-in-out 0s;
}

.pixelsSVG.active .svg-elem-1 {
  stroke-dashoffset: 0;
}

.pixelsSVG .svg-elem-2 {
  stroke-dashoffset: 240.00079345703125px;
  stroke-dasharray: 240.00079345703125px;
  transition: stroke-dashoffset 1s ease-in-out 0.25s;
}

.pixelsSVG.active .svg-elem-2 {
  stroke-dashoffset: 0;
}

.pixelsSVG .svg-elem-3 {
  stroke-dashoffset: 434.6922607421875px;
  stroke-dasharray: 434.6922607421875px;
  transition: stroke-dashoffset 1s ease-in-out 0.5s;
}

.pixelsSVG.active .svg-elem-3 {
  stroke-dashoffset: 0;
}

.pixelsSVG .svg-elem-4 {
  stroke-dashoffset: 319.40399169921875px;
  stroke-dasharray: 319.40399169921875px;
  transition: stroke-dashoffset 1s ease-in-out 0.75s;
}

.pixelsSVG.active .svg-elem-4 {
  stroke-dashoffset: 0;
}

.pixelsSVG .svg-elem-5 {
  stroke-dashoffset: 218px;
  stroke-dasharray: 218px;
  transition: stroke-dashoffset 1s ease-in-out 1s;
}

.pixelsSVG.active .svg-elem-5 {
  stroke-dashoffset: 0;
}

.pixelsSVG .svg-elem-6 {
  stroke-dashoffset: 335.00262451171875px;
  stroke-dasharray: 335.00262451171875px;
  transition: stroke-dashoffset 1s ease-in-out 1.25s;
}

.pixelsSVG.active .svg-elem-6 {
  stroke-dashoffset: 0;
}
</style>
